import { useMemo, useState } from "react";
import { TEST_CASES } from "../utils/sampleTemplates";

export const useTestCases = () => {
  const [activeCaseId, setActiveCaseId] = useState(TEST_CASES[0]?.id);

  const activeCase = useMemo(
    () => TEST_CASES.find((testCase) => testCase.id === activeCaseId),
    [activeCaseId]
  );

  return {
    activeCaseId,
    setActiveCaseId,
    activeCase,
    testCases: TEST_CASES,
  };
};


